// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_h1-0";
export var actionModalContentContainer = "_h1-1";
export var createTagButton = "_h1-2";
export var footerContainer = "_h1-7";
export var fullWidthDivider = "_h1-3";
export var hasCreateTagButton = "_h1-4";
export var noCreateTagButton = "_h1-5";
export var tagsContainer = "_h1-6";
export var tagsModalContentContainer = "_h1-8";